import React from "react"

export default function Blog035() {
  return (
    <section>
    <article>
    <h2>35. 01-04-2023</h2>
          <h3>mySQL or firebase?</h3>
          <p>
          <strong>Hi everyone!</strong>
          <br /><br />
          It's Eric here, and I'm excited to share the latest updates on my journey as a software developer. As you may know, I don't have a formal degree in computer science, but I've always been passionate about technology and have been teaching myself how to code for the past few years.
          <br /><br />
This past month has been a big one for me, as I started a new job as a software developer at In The Zone. It's a really exciting opportunity for me, and I'm learning a ton on the job. I've been working on a variety of projects, including building web applications and working with databases.
<br /><br />
One thing that I've been really interested in lately is using MySQL as my database of choice. I've been using Firebase for a while now, but I've been hearing a lot of good things about MySQL and I'm thinking about giving it a try. This may also lead me to learning Python, as I'm interested in building full stack applications.
<br /><br />
In addition to my new job, I've also been working on a couple of personal projects. One of them is my own website, which I'm using to share updates on my journey as a developer and document my progress. The other project is a fake news website called Bahagafish News. It's just a bit of fun, but I've been having a great time creating content for it and learning more about web design and development in the process.
<br /><br />
I'm planning on recording a vlog this week to talk more about all of these updates and share some of the things I've learned over the past month. I hope you'll tune in and follow along with my journey.
<br /><br />
Thanks for reading, and stay tuned for more updates!
<br /><br />
<br /><br />
Thanks for reading,<br />
Eric Polley
<br />



         
          </p>
          
          </article>

        <h4>Links</h4>
        <br />
        <ul>
        <li>
            <a
              href="http://news.ericpolley.com/"
              title="BAHAGAFISH!"
              target="_blank"
              rel="noopener noreferrer" 
            >
              <strong><p>BAHAGAFISH NEWS</p></strong></
            a>
          </li>
        
          <li>
            <a
              href="http://ericpolley.com"
              title="Check out my Portfolio!"
              target="_blank"
              rel="noopener noreferrer" 
            >
              <strong><p>Eric Polley's Website</p></strong></a
            >
          </li>
        </ul>
        </ section >
  )
}
